import type { BlockRendererProps } from '../registry';

export function PlanBlockRenderer({ block }: BlockRendererProps) {
  const steps = (block.metadata?.steps as string[] | undefined) ?? [];

  if (steps.length === 0) {
    return (
      <div className="text-sm text-muted-foreground italic">{block.content || 'Planning...'}</div>
    );
  }

  return (
    <div className="mt-1">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
        Plan
      </div>
      <ol className="list-decimal list-inside text-sm space-y-0.5">
        {steps.map((step, i) => (
          <li key={i}>{step}</li>
        ))}
      </ol>
    </div>
  );
}
